/* eslint-disable import/no-extraneous-dependencies, consistent-return */
import React, { ReactNode, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { Icon, ButtonActionSubtle } from '@honeycomb-npm/honeycomb-react';
import { content } from '../../../utils/contentUtils';
import { focusBladeHeading } from '../../../utils/scroller';

import './Blade.scss';

export interface Props {
  id: string;
  children: ReactNode;
  shouldVerticalAlign: boolean;
  hasImage?: boolean;
  className?: string;
  visibility: boolean;
  isGoToPreviousBlade?: boolean;
  isLoaded?: boolean; // This state is focussing focussing blade manually when the spinner is hidden
  goToPreviousBladeClick?: (blade: string) => void;
}

const Blade = ({
  id,
  className,
  children,
  shouldVerticalAlign,
  hasImage = false,
  visibility,
  isGoToPreviousBlade = true,
  isLoaded = false,
  goToPreviousBladeClick,
}: Props) => {
  const bladeRef = useRef<HTMLElement>(null);
  useEffect(() => {
    // When loader is hidden focus the blade manually
    if (isLoaded) {
      return focusBladeHeading(bladeRef.current);
    }
  }, [isLoaded, bladeRef]);

  if (!visibility) {
    return null;
  }

  return (
    <section
      className={classNames('blade', className, {
        'blade--vertical': shouldVerticalAlign,
        'blade--image': hasImage,
      })}
      id={`blade-${id}`}
      ref={bladeRef}
    >
      <div
        className={classNames('blade__content py-4', {
          'blade__content--previous-page-wrapper': isGoToPreviousBlade,
        })}
      >
        {isGoToPreviousBlade && (
          <div className="container">
            <div className="col-12">
              <Icon
                symbol="controlAccordionClose24"
                iconClassName="previous-page-icon"
                className="blade__go-to-previous-page"
              >
                <ButtonActionSubtle
                  id={`${id}-previous-blade-button`}
                  onClick={goToPreviousBladeClick}
                >
                  {content.previousScreen.previousLabel}
                </ButtonActionSubtle>
              </Icon>
            </div>
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

export default Blade;
